import Config from '../config';
const stripe = Stripe(Config.config.stripe.publishable_key);
export default stripe;